<div class="formfield formfield--innerlabel">
  <ns-type-ahead [cypress]="selectedStation?.id"
    suggestIcon="autosuggest__link--station"
    placeholder="station"
    [label]="label"
    [searchControl]="searchControl"
    [searchFn]="searchFn"
    (suggestionSelected)="selected.emit($event['subject'])"
    (focus)="onFocus($event)"
    (focusout)="onFocusOut($event)">
  </ns-type-ahead>

  <div *ngIf="requiredError">
    <ng-container>
      <nes-error-message>
        {{ "COMPOSE.ROUTE.ERROR_REQUIRED" | translate }}
      </nes-error-message>
    </ng-container>
  </div>

  <div *ngIf="stationsLoading"
    class="basicLoader">
  </div>
</div>
